<template>
  <div id="config-identity-wrapper">
    <div class="config-identity-column">
      <Input
        class="identity-input"
        heading="Business Name"
        type="text"
        :initialValue="businessName"
        @scs-input="autoSaveInput($event, 'business_name')"
      />
      <Input
        class="identity-input"
        heading="Business Phone Number"
        :initialValue="businessPhoneNumber"
        type="text"
        @scs-input="autoSaveInput($event, 'phone_number')"
      />
      <Input
        class="identity-input"
        heading="Business Email Address"
        type="text"
        :initialValue="emailAddressValue"
        :suffix="emailSuffix"
        @scs-input="emailAddressInput"
        @scs-blur="addEmailAddress"
      />
      <div
        class="email-address"
        v-for="(address, index) in emailAddresses"
        :key="index"
      >
        <p>
          {{ address }}
        </p>
        <round-button-with-icon icon="x" @click="deleteEmailAddress(index)" />
      </div>
      <image-input
        class="identity-input"
        heading="Business Logo"
        :initial="businessLogo"
        @scs-input="photoInput"
      />
    </div>
    <div class="config-identity-column">
      <Input
        class="identity-input"
        heading="Address"
        placeholder="12345 Anywhere St"
        :initialValue="businessAddress.streetAddress1"
        @scs-input="autoSaveInput($event, 'street_address_1')"
      />
      <Input
        class="identity-input"
        placeholder="Apt 12345"
        :initialValue="businessAddress.streetAddress2"
        @scs-input="autoSaveInput($event, 'street_address_2')"
      />
      <Input
        class="identity-input"
        placeholder="Anywhere, AZ, 12345"
        :initialValue="businessAddress.cityStateZip"
        @scs-input="autoSaveInput($event, 'city_state_zip')"
      />
      <color-set
        heading="Site Theme"
        :initial="colorTheme"
        :options="themeOptions"
        @scs-input="autoSaveInput($event, 'color_theme')"
      />
      <color-picker
        heading="Accent Color"
        :color="highlightColor"
        :options="accentOptions"
        :pickerEnabled="true"
        @scs-input="autoSaveInput($event, 'accent_color')"
      />
    </div>
  </div>
</template>
<script>
import Input from "../../../../Components/Elements/Input.vue";
import ColorSet from "../../../../Components/Elements/Color/ColorSet.vue";
import ColorPicker from "../../../../Components/Elements/Color/ColorPicker.vue";
import ImageInput from "../../../../Components/Elements/PhotoInput.vue";
import RoundButtonWithIcon from "@/Components/UI/RoundButtonWithIcon.vue";

export default {
  data() {
    return {
      emailAddressValue: undefined,
      initialColors: ["#D9D9D9", "#575757", "#FFFFFF"],
      themeOptions: [
        ["#FFFFFF", "#D9D9D9", "#575757"],
        ["#F2F4F9", "#B2C6D4", "#0A1D50"],
        ["#E3E0DE", "#B9A69C", "#311602"],
        ["#F7F7F7", "#8B8B8B", "#444444"],
        ["#FFF5EC", "#E6D9CB", "#897C6E"],
        ["#000000", "#292929", "#9B9B9B"],
        ["#FFF6F9", "#F4DFE5", "#967B83"],
      ],
      accentOptions: [
        "#FF0000",
        "#FF8A00",
        "#FFF500",
        "#52FF00",
        "#0047FF",
        "#9600FF",
        "#FF00A8",
        "#FAA1AA",
        "#FFCD9F",
        "#FFF8BC",
        "#CEFFB7",
        "#C2D3FF",
        "#ECD0FF",
        "#FFDEF4",
        "#590A0A",
        "#84450B",
        "#7D7000",
        "#1D4D07",
        "#0A1D50",
        "#3B0D5B",
        "#490933",
        "#745959",
        "#8D7966",
        "#84805F",
        "#5d6d56",
        "#545969",
        "#60516B",
        "#705466",
        "#ff8799",
        "#ffb58c",
        "#fff690",
        "#9dffd6",
        "#97b4ff",
        "#bda6f6",
        "#ff95db",
        "#FFEAF0",
      ],
    };
  },
  computed: {
    businessLogo() {
      return this.$store.getters.businessLogo;
    },
    businessName() {
      return this.$store.getters.businessName;
    },
    businessPhoneNumber() {
      return this.$store.getters.businessPhoneNumber;
    },
    emailAddresses() {
      return this.$store.getters.businessEmailAddresses;
    },
    emailSuffix() {
      return `@${this.businessName
        .replaceAll(" ", "")
        .toLowerCase()}.spindj.io`;
    },
    businessAddress() {
      return this.$store.getters.businessAddress;
    },
    colorTheme() {
      return this.$store.getters.colorTheme;
    },
    highlightColor() {
      return this.$store.getters.highlightColor;
    },
  },
  methods: {
    emailAddressInput(value) {
      this.emailAddressValue = value;
    },
    async addEmailAddress() {
      if (this.emailAddressValue) {
        this.$store.commit("updateConfig", {
          category: "identity",
          variable: "emailAddresses",
          operation: "add",
          subject: this.emailAddressValue + this.emailSuffix,
        });
        this.emailAddressValue = undefined;
      }
    },
    deleteEmailAddress(index) {
      this.$store.commit("updateConfig", {
        index: index,
        category: "identity",
        variable: "emailAddresses",
        operation: "delete",
      });
    },
    async autoSaveInput(value, variable) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        await this.updateConfig(value, variable);
      }, 750);
    },
    async updateConfig(value, variable) {
      this.$store.commit("updateConfig", {
        category: "identity",
        variable: variable,
        subject: value,
      });
    },
    // async photoInput(photo) {
    //   await this.$store.dispatch("addPhoto", photo).then((res) => {
    //     this.updateConfig(res, "business_logo");
    //   });
    // },
  },
  created() {},
  components: {
    Input,
    ColorSet,
    ColorPicker,
    ImageInput,
    RoundButtonWithIcon,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-identity-wrapper {
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /* padding: 20px; */
    width: 100%;
    box-sizing: border-box;
  }

  .config-identity-column {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: space-evenly; */
  }

  .email-address {
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    text-align: right;
    width: 100%;
  }

  .email-address > p {
    width: 100%;
    margin: 0;
  }

  .identity-input {
    width: 100%;
    margin: 5px;
  }
  @media (min-width: 800px) {
    #config-identity-wrapper {
      margin: auto;
      display: flex;
      flex-direction: row;
      /* width: 90%; */
      justify-content: space-around;
      align-items: center;
      /* padding: 50px; */
      box-sizing: border-box;
    }

    .config-identity-column {
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      /* justify-content: space-evenly; */
    }

    .email-address {
      display: flex;
      align-items: center;
      font-size: 0.85rem;
      text-align: right;
      width: 100%;
    }

    .email-address > p {
      width: 100%;
      margin: 0;
    }

    .identity-input {
      width: 100%;
      margin: 5px;
    }
  }
}
</style>
